import {makeStyles} from 'tss-react/mui'

export const useStyles = makeStyles()(() => ({
  iconRoot: {
    width: '18px',
    height: '18px'
  }
}))
